(() => {
  const init = () => {
    if (document.querySelector('.nex3d-purchase-bar')) return;
    const t = window.nex3dPurchaseText || {};
    const root = window.Shopify?.routes?.root || '/';
    const info = document.querySelector('product-info');
    const bar = document.createElement('aside');
    bar.className = 'nex3d-purchase-bar';
    bar.setAttribute('aria-label', t.label || 'Shopping actions');
    bar.innerHTML = '<div class="nex3d-purchase-bar__summary"><span class="nex3d-purchase-bar__title"></span><span class="nex3d-purchase-bar__variant"></span></div><button type="button" class="nex3d-purchase-bar__options"></button><button type="button" class="nex3d-purchase-bar__action"></button><button type="button" class="nex3d-purchase-bar__buy"></button>';
    document.body.append(bar);
    const title = bar.querySelector('.nex3d-purchase-bar__title');
    const variant = bar.querySelector('.nex3d-purchase-bar__variant');
    const action = bar.querySelector('.nex3d-purchase-bar__action');
    const buy = bar.querySelector('.nex3d-purchase-bar__buy');
    const options = bar.querySelector('.nex3d-purchase-bar__options');
    options.textContent = t.options || 'Choose options';
    buy.textContent = t.buy || 'Buy now';
    if (info) {
      const target = () => info.querySelector('product-form [name="add"],.product-form--quote-only a.product-form__submit');
      function sync() {
        const button = target();
        bar.hidden = !button;
        title.textContent = info.querySelector('.product__title h1')?.textContent.trim() || '';
        const values = [...info.querySelectorAll('variant-selects select option:checked,variant-selects input[type=radio]:checked')].map(e => e.value).filter(v => v !== 'Default Title');
        const price = info.querySelector('.price--on-sale .price-item--sale')?.textContent.trim() || info.querySelector('.price-item--regular')?.textContent.trim() || '';
        const quantity = info.querySelector('[name="quantity"]')?.value || '1';
        const selection = [values.join(' / '), `${t.qty || 'Qty'} ${quantity}`].filter(Boolean).join(' · ');
        let details = variant.querySelector('.nex3d-purchase-bar__selection');
        let amount = variant.querySelector('.nex3d-purchase-bar__amount');
        if (!details) {
          details = document.createElement('span');
          details.className = 'nex3d-purchase-bar__selection';
          amount = document.createElement('span');
          amount.className = 'nex3d-purchase-bar__amount';
          variant.replaceChildren(details, amount);
        }
        details.textContent = selection;
        details.title = selection;
        amount.textContent = price.replace(/\s+/g, ' ');
        options.hidden = !info.querySelector('variant-selects');
        action.textContent = button?.querySelector('span')?.textContent.trim() || button?.textContent.trim() || t.add || 'Add to cart';
        action.disabled = !button || button.disabled || button.getAttribute('aria-disabled') === 'true';
        buy.disabled = action.disabled;
        buy.hidden = !button?.closest('product-form');
      }
      const submit = checkout => {
        const button = target();
        if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return;
        const form = button.closest('form');
        if (form && !form.reportValidity()) { form.scrollIntoView({block:'center'}); return; }
        const productForm = button.closest('product-form');
        if (checkout && productForm) productForm.dataset.nex3dCheckout = 'true';
        button.click();
      };
      options.onclick = () => {
        const picker = info.querySelector('variant-selects');
        picker?.scrollIntoView({block:'center',behavior:'smooth'});
        picker?.querySelector('summary,select:not([aria-hidden="true"]),input:not([type="hidden"]),button')?.focus({preventScroll:true});
      };
      action.onclick = () => submit(false);
      buy.onclick = () => submit(true);
      new MutationObserver(sync).observe(info,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['disabled','aria-disabled','value','checked']});
      info.addEventListener('change',sync);
      info.addEventListener('input',sync);
      sync();
    } else {
      bar.classList.add('nex3d-purchase-bar--browse','nex3d-purchase-bar--empty');
      const browse = () => { const grid = document.querySelector('#product-grid'); if (grid) grid.scrollIntoView({block:'start',behavior:'smooth'}); else location.href = root + 'collections/3d-printers'; };
      options.hidden = true;
      buy.hidden = true;
      const syncCart = async () => {
        try {
          const response = await fetch(root + 'cart.js');
          if (!response.ok) return;
          const cart = await response.json();
          bar.classList.toggle('nex3d-purchase-bar--empty', !cart.item_count);
          title.textContent = cart.item_count ? `${t.cart || 'Your cart'} · ${cart.item_count}` : t.browse || 'Ready for your next print?';
          variant.textContent = cart.item_count ? new Intl.NumberFormat(document.documentElement.lang || 'en-US',{style:'currency',currency:cart.currency}).format(cart.total_price / 100) : '';
          action.textContent = cart.item_count ? t.checkout || 'Checkout' : t.shop || 'Shop printers';
          action.onclick = () => { if(cart.item_count) location.href = root + 'checkout'; else browse(); };
        } catch (_) {}
      };
      title.textContent = t.browse || 'Ready for your next print?';
      action.textContent = t.shop || 'Shop printers';
      action.onclick = browse;
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate,syncCart);
      window.addEventListener('pageshow',syncCart);
      syncCart();
    }
  };
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init); else init();
})();
